export default __webpack_public_path__ + "static/media/redeem-coupon-image.b07e27a1.svg";